import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllTreatmentprotocol } from '../../store/Actions/PrakrutistandardAction';
import { Button, Modal, Popover, Space, Tag } from 'antd';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { ActionDeleteById } from '../../store/Actions/CommonAction';
import { matchPermissions } from '../../utils/Permission';
import AdvancedColumnFilter from '../../components/Filters/AdvancedColumnFilter';
import useAdvancedFilters from '../../hooks/useAdvancedFilters';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { plusicon, refreshicon } from '../../components/imagepath';
import { CustomTable } from '../../components/Table';
import { PERMISSIONS } from '../../constants';


const TreatmentProtocolList = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const { Treatmentprotocollist, loader } = useSelector(state => state?.PrakrutiStandard);
  const { userDetails } = useSelector(state => state?.auth);
  const pageSize = 10;

  // Initialize Advanced Filters
  const {
    applyFilter,
    removeFilter,
    getFilterValue,
    clearAllFilters,
    hasActiveFilters,
    currentPage,
    setPage,
    buildQueryString,
    filters,
  } = useAdvancedFilters({
    allowedFilters: ['treatmentName'],
    resetPageOnFilter: true,
  });

  // Fetch data when filters change
  useEffect(() => {
    const queryForApi = buildQueryString();
    dispatch(GetAllTreatmentprotocol({ Query: queryForApi }));
  }, [buildQueryString, dispatch]);

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.PRAKRUTI_STANDARDS.TREATMENT_PROTOCOL.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.PRAKRUTI_STANDARDS.TREATMENT_PROTOCOL.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.PRAKRUTI_STANDARDS.TREATMENT_PROTOCOL.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.PRAKRUTI_STANDARDS.TREATMENT_PROTOCOL.CREATE);

  const content = item => (
    <div className="row col">
      {canUpdate && (
        <Button
          className="col m-2"
          onClick={() => {
            window.location.href = `/add-treatmentprotocol?update=true&&page=${currentPage}&&id=${item?.id}`;
          }}
        >
          Edit{' '}
        </Button>
      )}
      {/*
            TEMP_DELETE
            {canDelete &&
                <Button className="col m-2" onClick={() => showDeleteConfirm(item)}>Delete </Button>
            } */}
    </div>
  );
  /* eslint-disable no-unused-vars */
  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.treatmentName} name?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteById({ Query: `admin/treatment-protocol/${item?._id}` }, Res => {
            if (Res?.statusCode === 200) {
              const refreshQuery = buildQueryString();
              dispatch(GetAllTreatmentprotocol({ Query: refreshQuery }));
            }
          })
        );
      },
      onCancel() {
        return;
      },
    });
  };
  const columns = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      render: (text, record, index) => {
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Treatment Name',
      dataIndex: 'treatmentName',
      ...AdvancedColumnFilter({
        dataIndex: 'treatmentName',
        onFilter: applyFilter,
        onReset: removeFilter,
        currentValue: getFilterValue('treatmentName'),
        type: 'text',
        placeholder: 'Search treatment name',
      }),
      sorter: (a, b) => a.treatmentName?.localeCompare(b.treatmentName),
    },
    {
      title: !canUpdate && !canDelete ? null : 'Action',
      dataIndex: 'roleName',
      render: (text, record) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover placement="top" title={text} content={() => content(record)}>
              <Button type="text">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/treatmentprotocol-list?page=1">Treatment Protocol</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Treatment Protocol List</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  {/* Clear All Filters Button */}
                  {hasActiveFilters() && (
                    <div
                      style={{
                        padding: '16px',
                        background: '#fff',
                        marginBottom: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                      <Space>
                        <span style={{ fontWeight: 500 }}>Active Filters:</span>
                        <Tag color="blue">{Object.keys(filters).length} applied</Tag>
                        <Button onClick={clearAllFilters} danger size="small">
                          Clear All Filters
                        </Button>
                      </Space>
                    </div>
                  )}

                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Treatment Protocol List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCerate && (
                                    <Link
                                      to={`/add-treatmentprotocol`}
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}

                                  <Button
                                    onClick={() => {
                                      const queryForApi = buildQueryString();
                                      dispatch(GetAllTreatmentprotocol({ Query: queryForApi }));
                                    }}
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        {canView ? (
                          <CustomTable
                            TotalPageList={Treatmentprotocollist?.[0]?.totalDocs || 0}
                            column={columns}
                            OnChange={setPage}
                            CurrentPageNum={currentPage}
                            dataSource={Treatmentprotocollist?.[0]?.docs || []}
                            dataSourceLength={Treatmentprotocollist?.[0]?.docs?.length || 0}
                            pageSize={pageSize}
                            loader={loader}
                            ShowHeader={true}
                            Header={<div className="staff-search-table"></div>}
                            key={'treatment-protocol-table'}
                          />
                        ) : (
                          <div className="permission-denied-message">
                            You do not have permission to view the Treatment Protocol list.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default TreatmentProtocolList;
